import { CARRIER_TYPE_LABELS, SUPPLY_CHAIN_LEG_LABELS } from '../constants';

// Keys match LEG_PROFILES in onward-functions/src/auth/corpCarriers.js — the backend
// owns what each one resolves to (role, carrier_type, supply_chain_legs); the drawer
// only ever sends the key. Labels are composed from the page's existing label maps so
// they can't drift from how the same carrier renders in the table below.
const legLabel = (carrier_type, leg) => `${CARRIER_TYPE_LABELS[carrier_type]} · ${SUPPLY_CHAIN_LEG_LABELS[leg]}`;

export const LEG_OPTIONS = [
    { value: 'FM_CARRIER', label: legLabel('AGENT', 'FINAL_MILE') },
    { value: 'MM_CARRIER', label: legLabel('LTL', 'MIDDLE_MILE') },
    { value: 'FLEX', label: legLabel('FLEX', 'WAREHOUSE') },
    { value: 'TRUCKLOAD', label: legLabel('PARTNER', 'E2E') },
    { value: 'GIG', label: legLabel('GIG', 'GIG') },
    { value: 'CONTRACTOR', label: 'Motor carrier · contractor' },
];

export const DEFAULT_LEG = 'FM_CARRIER';

// The template's columns, matching the format the drawer advertises exactly. There is
// deliberately no Leg column and none is read from an upload — the leg comes from the
// drawer's selector, which applies to the whole file. See CSV_HEADER_ALIASES.
export const CARRIER_CSV_COLUMNS = ['Name', 'Alias', 'DOT', 'Invite Email', 'Address', 'City', 'State', 'Zip'];

// Header → normalized row field. Several spellings per field because these files come
// from carrier-procurement spreadsheets, not from an export we control.
//
// Deliberately no `leg` entry. A Leg column isn't in the template, so nobody uploading a
// file knows to supply one or which values it takes — and the spellings it would need
// ('type', 'carrier type') are generic enough that an unrelated column would silently
// override the drawer's leg selector for every row, with nothing on screen to reveal it.
// One leg per upload, chosen visibly, beats a magic column.
export const CSV_HEADER_ALIASES = {
    business_name: [
        'name',
        'carrier',
        'carrier name',
        'legal name',
        'legal business name',
        'business name',
        'company',
        'company name',
        'dba',
    ],
    alias: ['alias', 'carrier alias'],
    dot_number: ['dot', 'dot #', 'dot number', 'dot num', 'usdot', 'usdot #', 'us dot', 'dot_number'],
    mc_num: ['mc', 'mc #', 'mc num', 'mc number', 'docket', 'docket number'],
    email: ['invite email', 'email', 'e mail', 'contact email', 'primary email', 'contact'],
    business_address: ['address', 'street', 'street address'],
    business_city: ['city'],
    business_state: ['state', 'st', '2 letter state'],
    business_zip: ['zip', 'zipcode', 'zip code', 'postal code'],
    airport_codes: ['airport', 'airports', 'airport code', 'airport codes'],
};

export const DEDUPE_NOTE_LEAD = 'We check every DOT against Onward. ';
export const DEDUPE_NOTE_EMPHASIS = 'Matches go to review';
export const DEDUPE_NOTE_TAIL = ' before anything is added. Rows without a DOT are added as new.';

// Row-level decisions in the Upload Exceptions modal. There is no default: a flagged
// row is connected to one of the existing accounts it matched, skipped, or added as
// its own account, and the operator has to say which before the batch commits.
export const CONFLICT_ACTIONS = {
    CONNECT: 'CONNECT',
    ADD_ANYWAY: 'ADD_ANYWAY',
    SKIP: 'SKIP',
};
